import { useEffect } from "react";
import { useLocation } from "react-router";

import { faro } from "@grafana/faro-react";

export function TrackFaroView() {
  const { pathname } = useLocation();

  useEffect(() => {
    faro.api.setView({ name: pathname });
  }, [pathname]);

  return null;
}
